export const URL_RECARGARCUPO_WITH_PASARELA = `${process.env.REACT_APP_URL_CORRESPONSALIA_OTROS}/services_pasarela/recargar_cupo/inicio`;
